// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
export { default } from '/mnt/node_modules/dumi/theme-default/slots/SourceCodeEditor/index.js';
